<template>
    <div class="c-reservation-select">
        <div class="c-reservation-select__holder js-reservation-select-holder" v-show="branches.length > 1">
            <input name="branch_id" type="hidden" :value="selectedBranchId" />

            <button
                class="c-reservation-select__button"
                @click="onSelectClick"
                type="button"
                :disabled="!isInitialized"
            >
                <span class="sc-text">{{ selectButtonLabel }}</span>
                <i class="ico ico-chevron-down-thick"></i>
            </button>

            <div class="c-reservation-select__dropdown" v-show="isExpanded">
                <button
                    class="c-reservation-select__item"
                    type="button"
                    v-for="branch in branches"
                    :key="`branch-${branch.id}`"
                    @click.prevent="onBranchClick(branch.id)"
                >
                    <strong>{{ branch.name }}</strong>
                    <small>{{ branch.street }}</small>
                </button>
            </div>
        </div>

        <div class="c-reservation-select__info c-reservation-select__info--placeholder" v-if="!selectedBranch">
            <div class="sc-empty-bar sc-empty-bar--long"></div>
            <div class="sc-empty-bar"></div>
            <div class="sc-empty-bar"></div>
        </div>

        <div class="c-reservation-select__info" v-else>
            <div class="sc-info-item">
                <div class="sc-content">
                    <strong>{{ selectedBranch.street }}, {{ selectedBranch.post_code }} {{ selectedBranch.city }}</strong>
                </div>
            </div>

            <div class="sc-info-item" v-if="selectedBranch.description">
                <div class="sc-content" v-html="selectedBranch.description"></div>
            </div>

            <div class="sc-info-item" v-if="selectedBranch.lunch_break">
                <div class="sc-content" v-html="selectedBranch.lunch_break"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
    data() {
        return {
            isExpanded: false,
        }
    },
    mounted() {
        document.addEventListener('click', (event) => {
            if (
                !this.isExpanded ||
                event.target.closest('.js-reservation-select-holder') ||
                event.target.classList.contains('js-reservation-select-holder')
            ) {
                return true
            }

            this.isExpanded = false
        })
    },
    methods: {
        ...mapMutations([
            'selectBranch',
            'selectBranchId',
        ]),
        onSelectClick() {
            this.isExpanded = !this.isExpanded;
        },
        onBranchClick(branchId) {
            this.isExpanded = false
            this.selectBranch(branchId)
        }
    },
    computed: {
        ...mapState([
            'branches',
            'selectedBranchId',
            'isInitialized',
        ]),
        ...mapGetters([
            'selectedBranch',
        ]),
        selectButtonLabel() {
            if (!this.selectedBranch) {
                return this.$t('BranchReservation.Select.empty')
            }

            return `${this.selectedBranch.name}, ${this.selectedBranch.street}`
        }
    }
}
</script>